<ng-container
    *ngIf="{
        required: required$ | async,
    } as data"
>
    <bazis-grid
        class="bazis-grid_form bazis-map-point-control"
        *transloco="let t"
    >
        <bazis-row *ngIf="titleKey">
            <bazis-col>
                <bazis-label
                    [title]="t(titleKey, titleParams)"
                    [required]="data.required"
                >
                    <bazis-interrogation
                        *ngIf="tooltipKey"
                        [slot]="tooltipSettings?.targetSide"
                        iconSize="compact"
                        [tooltipText]="t(tooltipKey, tooltipParams)"
                        [tooltipOffset]="[-8, 4]"
                        [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                        [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
                        [icon]="icons.interrogation"
                        [type]="interrogationType"
                    ></bazis-interrogation>
                </bazis-label>
            </bazis-col>
        </bazis-row>

        <bazis-row class="tms-control_no-margin">
            <bazis-col
                sizeSm="6"
                sizeXs="12"
            >
                <bazis-input-number
                    [id]="anchorRoot ? anchorRoot + '-lat-' : null"
                    [formControl]="lat"
                    [placeholderKey]="latPlaceholderKey"
                    [titleKey]="latTitleKey"
                    [required$]="required$"
                ></bazis-input-number>
            </bazis-col>
            <bazis-col
                sizeSm="6"
                sizeXs="12"
            >
                <bazis-input-number
                    [id]="anchorRoot ? anchorRoot + '-lng-' : null"
                    [titleKey]="lngTitleKey"
                    [placeholderKey]="lngPlaceholderKey"
                    [formControl]="lng"
                    [required$]="required$"
                ></bazis-input-number>
            </bazis-col>
        </bazis-row>
        <bazis-row class="bh-margin-bottom-4x">
            <bazis-col>
                <div
                    class="bazis-control__error"
                    *ngIf="lat.valid && lng.valid"
                >
                    <bazis-form-error [formControl]="ngControl.control"></bazis-form-error>
                </div>
                <div
                    *ngIf="noteKey"
                    class="bazis-control__note"
                >
                    {{ t(noteKey, noteParams) }}
                </div>
            </bazis-col>
        </bazis-row>
    </bazis-grid>
</ng-container>
